module.exports = __webpack_public_path__ + "assets/img/step3-sz.d5955572.png";